<template>
  <div>
    <div v-if="studiesData !== null && studiesData !== undefined && studiesData.length > 1" :class="{ 'forgot-pass-box text-center': forgotFlow == false }">
      <div
        :class="{
          'signIn-box text-center forgot-container': forgotFlow,
          'margin-60': forgotFlow == false
        }"
      >
        <div class="Participant-box text-center">
          <div class="Select-study-title mb-48" v-translate:label_select_study="lang">
            Select a study
          </div>
          <div class="text-center pid-title" v-translate:pweb_select_study="lang">
            Please select the study from the dropdown below that you need to access.
          </div>
          <!-- <p v-translate:pweb_help_text_language_country="lang">Please use the dropdown below to select a specific study you are a part of.</p> -->
          <div class="form-group pt-55" style="position:relative">
            <select class=" form-control floating-select" id="participant-select" style="height:56px" v-model="selectedStudyId" @change="setValueAttribute('participant-select', selectedStudyId)" value="">
              <option v-for="(study, i) in studiesData" :key="i" :value="study.studyId">{{ study.studyName }}</option>
            </select>
            <label class="label" v-translate:pweb_select_study="lang">Please select a study</label>
          </div>
          <button type="submit" :disabled="!selectedStudyId" class="signIn-btn pid-btn btn mt-100" @click="newStudySelected()" v-translate:label_continue="lang">
            Continue
          </button>
        </div>
      </div>
    </div>
    <Modal :show="showConfirmationModal" :title="modal.title" :helpText="modal.helpText" :cancelButton="modal.cancelBtnTitle" :okButton="modal.okBtnTitle" @modalCallback="modalCallback"></Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";
import nprogress from "nprogress";
import Modal from "@/components/participant-portal/common/modal";
import { sortBy } from "lodash";

export default {
  name: "login-studies",
  components: { Modal },
  props: ["studyId", "studies", "email", "eventType", "lang", "phoneFlag", "mobile", "studyType"],
  data() {
    return {
      loading: false,
      widget: new Widget(),
      portal: new ParticipantPortal(),
      studiesData: [],
      forgotFlow: false,
      selectedStudyId: null,
      showConfirmationModal: false,
      createNewUsername: false,
      usernameSent: false,
      modal: {
        title: null,
        helpText: null,
        cancelBtnTitle: null,
        okBtnTitle: null
      }
    };
  },
  mounted() {
    if (this.studies) {
      this.forgotFlow = true;
      this.studiesData = sortBy(this.studies, [
        function(o) {
          return o.studyName.toLowerCase().trim();
        }
      ]);
    } else if (this.email || this.phoneFlag) {
      nprogress.start();
      this.getStudies();
    }
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    }
  },
  watch: {},
  methods: {
    setValueAttribute(idName, value) {
      document.getElementById(idName).setAttribute("value", value);
    },
    navigate(studyId) {
      if (this.eventType == "username") {
        this.$emit("updateActiveScreen", {
          key: "resetUsername",
          flagKey: "createUsername",
          flagChild: "studyId",
          flagValue: studyId
        });
      } else if (this.eventType == "password") {
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "studyId",
          flagValue: studyId
        });
      } else {
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "studyId",
          flagValue: studyId
        });
      }
    },
    newStudySelected() {
      this.$emit("studySelected", this.selectedStudyId);
      if (this.pwebCognitoAuthentication && this.eventType == "username") {
        this.cognitoForgotUsername();
      } else if (this.pwebCognitoAuthentication == false && this.eventType == "password") {
        this.legacyForgotPassword();
      } else {
        this.navigate(this.selectedStudyId);
      }
    },
    getStudies() {
      this.loading = true;
      let studyPayload = {
        email: this.email,
        country: this.portal.getCountry(),
        deviceType: "web"
      };
      if (this.phoneFlag) {
        studyPayload = {
          mobile: this.mobile.number.significant,
          country: this.portal.getCountry(),
          deviceType: "web",
          verificationMethod: "phone"
        };
      }
      this.$api
        .getStudies(studyPayload)
        .then(
          response => {
            if (response.data.studies == null) {
              const message = this.widget.translate("DATA_SYNC_ERROR_MSG", "Problem in fetching study details.");
              this.$toastr.error(message);
              nprogress.done();
            } else if (response.data.studies.length == 1 || this.portal.getStudy()) {
              this.selectedStudyId = this.portal.getStudy() ? this.portal.getStudy() : response.data.studies[0].studyId;
              this.portal.setLocalStorage("pw-studyId", this.selectedStudyId);
              if (this.studyType == "singleStudy") {
                this.navigate(this.selectedStudyId);
              }
              if (this.pwebCognitoAuthentication && this.eventType == "username") {
                this.cognitoForgotUsername();
              } else if (this.pwebCognitoAuthentication == false && this.eventType == "password") {
                this.legacyForgotPassword();
              } else {
                this.navigate(this.selectedStudyId);
              }
              nprogress.done();
            } else {
              const studyRes = response.data && response.data.studies;
              if (studyRes.length) {
                this.studiesData = sortBy(studyRes, [
                  function(o) {
                    return o.studyName.toLowerCase().trim();
                  }
                ]);
              }
              nprogress.done();
            }
          },
          error => {
            nprogress.done();
            const message = this.widget.translate(error.message, "Problem in fetching study details.");
            this.$toastr.error(message);
          }
        )
        .catch(e => {
          nprogress.done();
          const message = this.widget.translate(e.message, "Problem in fetching study details.");
          this.$toastr.error(message);
        });
    },
    cognitoForgotUsername() {
      let payload = {
        email: this.email,
        language: this.portal.getLanguage(),
        studyId: this.selectedStudyId
      };
      if (this.phoneFlag) {
        payload = {
          mobile: this.mobile.number.significant,
          countryCode: "+" + this.mobile.country.dialCode,
          language: this.portal.getLanguage(),
          studyId: this.selectedStudyId
        };
      }
      this.$api.forgotUsernameFactParticipant(payload).then(res => {
        if (res.data.errorCode == null) {
          this.modal.title = this.widget.translate("pweb_title_username_sent", "Username Sent");
          this.modal.helpText = res.body.message != null && res.body.message.indexOf("sent to the verified phone number") != -1 ? this.widget.translate("lable_username_sent_to_verification_phone", res.body.message) : this.widget.translate("pweb_help_text_username_sent", "Your username has been sent to the email address you just provided.");
          this.modal.cancelBtnTitle = null;
          this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
          this.createNewUsername = false;
          this.showConfirmationModal = !this.showConfirmationModal;
        } else {
          if (res.data.errorMessage == "USER_DOES_NOT_HAVE_USERNAME") {
            this.modal.title = this.widget.translate("pweb_title_forgot_username_not_found", "There is no username associated to this account.");
            this.modal.helpText = this.widget.translate("pweb_help_text_forgot_username_not_found", "Would you like to create one now?");
            this.modal.cancelBtnTitle = this.widget.translate("label_cancel", "Cancel");
            this.modal.okBtnTitle = this.widget.translate("YES_TEXT", "Yes");
            this.showConfirmationModal = !this.showConfirmationModal;
            this.createNewUsername = true;
          } else {
            const message = this.widget.translate(res.data.errorMessage, res.data.message);
            this.$toastr.error(message);
            this.createNewUsername = false;
            this.modalCallback();
          }
        }
      });
    },
    legacyForgotPassword() {
      const postData = {
        email: this.email,
        language: this.portal.getLanguage(),
        studyId: this.selectedStudyId
      };
      this.showConfirmationModal = false;
      this.$api
        .postParticipantSendOtp(postData)
        .then(response => {
          if (response.data.success) {
            this.modal.title = this.widget.translate("RESET_CONTINUE", "Continue");
            this.modal.helpText = this.widget.translate("RESET_PSWRD_INSTRUCTION_EMAIL_MSG", "An email with instructions on how to reset your password has been sent to you.");
            this.showConfirmationModal = true;
            this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
          } else {
            const title = this.widget.translate("FORGOT_PASS_PWD", "Unable to verify email");
            this.$toastr.error(title);
            this.modalCallback();
          }
        })
        .catch(error => {
          if (error && error.data && error.data.message_key) {
            const title = this.widget.translate(error.data.message_key, "Unable to verify email");
            this.$toastr.error(title);
          }
        });
    },
    modalCallback() {
      if (this.createNewUsername) {
        this.navigate(this.selectedStudyId);
      } else {
        this.$router.push({ name: "participants-portal-auth-login" });
      }
    }
  }
};
</script>

<style scoped>
#participant-select.form-control {
  padding: 10px;
}
.forgot-container,
.loading {
  height: auto !important;
}
.Select-study-title {
  font-family: Roboto;
  font-size: 36px;
  font-weight: 300;
  line-height: 0.94;
  text-align: center;
  color: #4a4a4a;
}
label {
  position: absolute;
  pointer-events: none !important;
  left: 16px !important;
  top: 71px !important;
  font-size: 16px !important;
  line-height: 1.5 !important;
  letter-spacing: 0.15px !important;
  text-align: left !important;
  color: rgba(0, 0, 0, 0.6) !important;
  transition: all 0.2s ease;
  -moz-transition: 0.2s ease all;
  -webkit-transition: all 0.2s ease;
}
.floating-select:focus ~ .label,
.floating-select:not([value=""]):valid ~ .label {
  top: 45px !important;
  left: 8px !important;
  padding: 0 5px !important;
  font-size: 16px !important;
  text-align: left;
  color: #888;
  background-color: #fff !important;
}
.pid-title {
  font-family: Roboto;
  font-size: 16px;
  line-height: 1.31;
  letter-spacing: -0.32px;
  text-align: center;
  color: #4a4a4a;
}
</style>
